export { default } from "@workspace/gamja-platform/components/BlockEditor";
